export default __webpack_public_path__ + "static/media/IMG_2748.fc4dfcc6.jpg";